<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import { incomeExpense } from "../../../../services/financeservice/incomeExpense.service";
import { propertyService } from "../../../../services/propertyservice/property.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Expense Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
  },
  data() {
    return {
      dropdownSelection: {},
   
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "expense",
      breadCrumb: {},
      currency: "",
      project: 0,

      expenseData: null,
      projectData: {},
      propertyData: {},
      supplierData: {},
      sellerData: {},
      agencyData: {},
      currencyData: {},
      property: {},
      propertySelected: {},
      paymentMethodData: {},
      bankAccountData: {},
      itemData: {},
      valueItemEntries: [],

      dataProject: 0,
      dataLastProject: 0,
      dataReference: '',
      dataProperty: 0,
      dataCurrency: 0,
      dataAmount: 0,
      dataSupplier: 0,
      dataNotation: '',
      dataDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataBankAccount: 0,
      dataPaymentMethod: 1,
      dataItem: 1,
      dataJournalEntry: 0
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    this.dataCurrency = 1;

    // console.log("AAA", this.dataSeller);

    this.dataSchedule = [];

    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    } else {
      this.loadingData(0);     
    }
  },
  watch: {
      dataDiscount: function() { // watch it
        // console.log(newVal);
        // this.changeSellPrice();
      }
  },
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      incomeExpense.getOne(id)
        .then(response => {
            // this.breadCrumb = {
            //   text: response.data.name + " - (" + response.data.code + ")",
            //   active: true,
            // };
          if(id != 0){
            this.expenseData = response;
            this.dataProject = this.expenseData.data.project_id;
            this.dataProperty = this.expenseData.data.property_id;
            this.dataReference = this.expenseData.data.ref_no;
            this.dataCurrency = this.expenseData.data.currency_id;
            this.dataAmount = this.expenseData.data.amount;
            this.dataSupplier = this.expenseData.data.supplier_id;
            this.dataNotation = this.expenseData.data.notation;
            this.dataDate = this.expenseData.data.for_date;
            this.dataItem = this.expenseData.data.income_expense_item_id;
          }
          

          // console.log(response)
          this.loadingSettings(response.setting);
        });

    },

    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },

    loadingPropertyById: function(id) {

      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          this.fetchingStats = true;
          this.propertySelected = response.data;

          this.dataDiscount = 0;
          this.dataDiscountType = 2;
          this.dataBookingAmount = 0;
          this.dataBooking = 0;

          // if('collections' in this.propertySelected ) {

          //   this.propertySelected.collections.map(item => {
          //     if('bookings' in item) {
                
          //       let deposit = item.bookings[0];
          //       if(deposit) {
          //         this.dataDiscount = deposit.discount;
          //         this.dataDiscountType = deposit.discount_type;
          //         this.dataBookingAmount = deposit.booking_amount;
          //         this.dataBooking = deposit.id;
          //         this.dataPaymentMethod = deposit.payment_method_id;
          //         this.dataDepositDate = deposit.booking_date;
          //       }
          //     }
          //   });
            

          // }

          // console.log(JSON.stringify(this.propertySelected));

          let discount = this.dataDiscountType == 2 ? this.dataDiscount : (this.propertySelected.price * this.dataDiscount / 100);

          this.dataCustomer = this.propertySelected.customer_id == 0 ? this.propertySelected.temp_customer_id : this.propertySelected.customer_id;
          this.dataProperty = this.propertySelected.id;
          this.dataAmount = this.propertySelected.price;
          this.dataSalePrice = this.propertySelected.price - discount; // - this.dataBookingAmount;

          this.loadingSettings(response.setting);
        });
    },

    loadingPropertyData: function(projectId = 0) {
      propertyService.getDropdowns(projectId).then(response => {
        this.propertyData = response;
      });
    },


    loadingSettings: function(setting) {
      //paymentmethods
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
      this.paymentMethodData = {data: setting.paymentmethods};
      this.bankAccountData = {data: setting.bankaccounts};
      this.currencyData = {data: setting.currencies};
      this.supplierData = {data: setting.suppliers};
      this.itemData = {data: setting.incomeexpenseitems.filter((item) => item.item_type_id == 2)};

    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "expense-list"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let expense = {
        ref_no: this.dataReference,
        amount: this.dataAmount,
        currency_id: this.dataCurrency,
        project_id: this.dataProject,
        property_id: this.dataProperty,
        supplier_id: this.dataSupplier,
        for_date: this.dataDate,
        notation: this.dataNotation,
        received_date: this.dataDate,
        customer_id: 0,
        deposit_account_id: 0,
        type: 2,
        payment_method_id: this.dataPaymentMethod,
        bank_account_id: this.dataBankAccount,
        income_expense_item_id: this.dataItem,
        is_journal_entry: this.dataJournalEntry ? 1 : 0
      };

      // console.log(JSON.stringify(expense));

      if(this.isAdd) {
        incomeExpense.insert(expense)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.$router.push(this.$route.query.redirectFrom || {
                name: "expense-list"
              });
           }else{
             console.log(response)
           }
          
        });
      } else {

        incomeExpense.update(this.$route.params.id, expense)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "expense-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },


    clearForm: function() {

      this.dataProperty = 0;
      this.dataCurrency = 0;
      this.dataAmount = 0;

    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 

    projectChanged: function(event) {

      this.project = event;
      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }

      this.dataLastProject = event;
    },

    propertyChanged: function(property) {
      this.loadingPropertyById(property.id);      
    },

    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.dataBankAccount = 0;
      }
    },

    // addItem: function() {
    //   // console.log(item);
    //   let row = {
    //     label: '',
    //     item_id: '',
    //     quantity: 1,
    //     price: 0
    //   };

      
    //   this.valueItemEntries.push(row);

    //   this.valueItem = 0;
    // },

    // formatCurrency(value, sign = '', decimal = '.00') {
    //   return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    // },

    // getTotal() {
    //   return this.valueEntries.reduce((sum, val) => sum + (val.price * val.quantity), 0);
    // },

    // rowChanged: function(item, index) {
    //   this.valueEntries[index] = item;
    // },

    // rowDeleted: function(index) {
    //   this.valueEntries.splice(index, 1);
    // }
  },
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('expense.text'),
        href: '/general/sale',
      }, {
        text: $t('expense.add'),
        active: true
      }]" :title="this.isAdd ? $t('expense.add') : $t('expense.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('expense.text'),
        href: '/general/sale',
      }, this.breadCrumb]" :title="this.isAdd ? $t('expense.add') : $t('expense.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :editable="false"
                  v-model="dataProject"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Search 
                  :id="'property_id'"
                  :editable="true"
                  v-model="dataProperty"
                  :list="this.propertyData"
                  :require="true"
                  :label="'property.text'" 
                />
                
              </div>

              <div class="col-md-4">
                <!-- <Select 
                  :id="'supplier_id'"
                  :text="'label'"
                  v-model="dataSupplier"
                  :list="this.supplierData"
                  :label="'supplier.text'"  /> -->
                <Search 
                  :id="'supplier_id'"
                  :editable="true"
                  v-model="dataSupplier"
                  :list="this.supplierData"
                  :label="'supplier.text'"  />
              </div>
              
            </div>
            <div class="row">
            <div class="col-md-4">
                <Select
                  @change="currencyChanged" 
                  :id="'currency_id'"
                  :text="'label'"
                  :auto="true"
                  v-model="dataCurrency"
                  :list="this.currencyData"
                  :label="'property.currency'"
                    /> 
              </div>
              <div class="col-md-4">
                <Input 
                  :type="'date'"
                  :id="'for_date'"
                  v-model="dataDate"
                  :label="'expense.date'"  />
              </div>
             
              <div class="col-lg-4">
                <Input 
                  :type="'text'"
                  :id="'ref_no'"
                  v-model="dataReference"
                  :label="'expense.ref_no'"  />
              </div>
             
            </div>
            
            <div class="row">
              <div class="col-md-4">
                <Input 
                  :type="'number'"
                  :step="'0.01'"
                  :id="'amount'"
                  v-model="dataAmount"
                  :label="'expense.amount'"  />
              </div>
              <div class="col-lg-8">
                <Input 
                  :type="'text'"
                  :id="'notation'"
                  v-model="dataNotation"
                  :label="'expense.notation'"  />
            </div>
            
              
             
            </div>
            <div class="row">
              <div class="col-md-4">
                <Select
                  :id="'income_expense_item_id'"
                  v-model="dataItem"
                  :list="this.itemData"
                  :label="'expense.item-type'"
                    /> 
              </div>
              <div class="col-md-4">
                <Select
                  @change="paymentMethodChanged" 
                  :id="'payment_method_id'"
                  :auto="true"
                  v-model="dataPaymentMethod"
                  :list="this.paymentMethodData"
                  :label="'booking.payment-method'"
                    /> 
              </div>
              <div v-show="dataPaymentMethod == 2 || dataPaymentMethod == 3" class="col-md-4">
                <Select
                  :id="'bank_account_id'"
                  v-model="dataBankAccount"
                  :list="this.bankAccountData"
                  :label="'payment.bank_account'"
                    /> 
              </div>
              
            </div>
            <div class="row">
              <div class="col-md-6">
                  <div class="form-check form-switch form-switch-md mb-3">
                    <input
                      :disabled="!this.isAdd"
                      class="form-check-input"
                      type="checkbox"
                      id="exclude"
                      v-model="dataJournalEntry"
                    />
                    <label class="form-check-label" for="exclude"
                      >{{$t('report.income_expense.journal-entry')}}</label
                    >
                  </div>
                </div>
            </div>
            <br><br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>